import React, { forwardRef } from "react";
import { Options } from "../../../shared/lib/types";
import MultiSelect, { MultiSelectProps, OptionType } from "./MultiSelect";
import { SelectInstance } from "react-select";

const MultiSelectForOptions = forwardRef<
  SelectInstance<OptionType, true>,
  {
    options: Options;
    value: string[];
    onChange: (value: string[]) => void;
  } & Omit<MultiSelectProps, "options" | "value" | "onChange">
>(function MultiSelectForOptions({ options, value, onChange, ...props }, ref) {
  return (
    <MultiSelect
      options={options.map((option) => ({
        label: option.name,
        value: option.id.toString(),
      }))}
      value={value.map((v) => ({
        label: options.find((option) => option.id.toString() === v)?.name || "",
        value: v,
      }))}
      onChange={(selectedOptions) => {
        onChange(selectedOptions.map((option) => option.value));
      }}
      ref={ref}
      {...props}
    />
  );
});

export default MultiSelectForOptions;
